import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { IWarehouse } from '../../../../../@interfaces/warehouse.interface';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
  ReactiveFormsModule,
  FormsModule,
} from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { WarehouseService } from '../../../../../@pages/warehouse/warehouse.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';

import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-crud-warehouse',
  templateUrl: './crud-warehouse.component.html',
  styleUrls: ['./crud-warehouse.component.css'],
  imports: [
    MatDialogModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatButtonModule,
    TranslatePipe,
  ],
})
export class CrudWarehouseComponent implements OnInit, OnDestroy {
  @Input() listWare: IWarehouse[] = [];
  registerForm: UntypedFormGroup = this.fb.group({
    warehouse: ['', [Validators.required]],
  });
  unsubscribe$ = new Subject<void>();
  constructor(
    private fb: UntypedFormBuilder,
    private warehouse: WarehouseService,
    private router: Router,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.warehouse
      .listWarehouses()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((result) => {
        this.listWare = result;
      });
  }

  remove(id: number, index: number) {
    Swal.fire({
      title: this.translate.instant('Are you sure?'),
      text: this.translate.instant('You won not be able to revert this!'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#ff5400',
      cancelButtonColor: 'rgb(0, 0, 0)',
      confirmButtonText: 'Confirm',
    }).then((confirm) => {
      if (confirm.isConfirmed) {
        this.warehouse
          .removeWarehouse(id)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe((result) => {
            if (!result) {
              Swal.fire(
                'Error',
                this.translate.instant('Something was wrong'),
                'error',
              );
            } else {
              Swal.fire(
                this.translate.instant('Good'),
                this.translate.instant('Warehouse removed'),
                'success',
              ).then((data) => {
                if (data.isConfirmed) {
                  this.router
                    .navigateByUrl('/dialog', { skipLocationChange: true })
                    .then(() => {
                      this.router.navigate(['/inventory']);
                    });
                  this.warehouse
                    .listWarehouses()
                    .pipe(takeUntil(this.unsubscribe$))
                    .subscribe((result) => {
                      this.listWare = result;
                    });
                }
              });
            }
          });
      }
    });
  }

  update() {
    if (this.registerForm.invalid === true) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: this.translate.instant('Warehouse Invalid, Please Check!'),
      });
      return;
    }
    this.warehouse
      .createWarehouse(this.registerForm.get('warehouse')?.value)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((result) => {
        if (result) {
          Swal.fire({
            title: this.translate.instant('Created'),
            text: this.translate.instant('Warehouse created successfully!'),
            icon: 'success',
            showCancelButton: false,
            confirmButtonColor: '#f44336',
            confirmButtonText: 'Ok',
          }).then((data) => {
            if (data.isConfirmed) {
              this.router
                .navigateByUrl('/dialog', { skipLocationChange: true })
                .then(() => {
                  this.router.navigate(['/inventory']);
                });
              this.warehouse
                .listWarehouses()
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((result) => {
                  this.listWare = result;
                });
            }
          });
        } else {
          Swal.fire(
            this.translate.instant('Something was wrong'),
            this.translate.instant('Failed'),
            'error',
          );
        }
      });
  }

  textValid(text: string, index?: number) {
    return (
      this.registerForm.get(text)?.invalid &&
      this.registerForm.get(text)?.touched
    );
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
